import React from 'react';

/**
 * Small additions vs deletions donut for commit tables (SVG stroke).
 * Counts are shown beside the donut in the table, not in a hover tooltip.
 * @param {{ additions?: number, deletions?: number, size?: number }} props
 */
export default function CommitAddDelDonut({ additions = 0, deletions = 0, size = 34 }: any) {
  const a = Math.max(0, Number(additions) || 0);
  const d = Math.max(0, Number(deletions) || 0);
  const total = a + d;
  const label = total === 0 ? 'No additions or deletions' : `${a} additions, ${d} deletions`;

  const pad = 1;
  /* Ring thickness scales with size; ~18% thicker than previous (0.068) for commit-table readability. */
  const strokeWidth = Math.max(2.25, size * 0.08);
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - strokeWidth / 2 - pad;
  const circumference = 2 * Math.PI * r;

  const addLen = total > 0 ? (a / total) * circumference : 0;
  const delLen = total > 0 ? (d / total) * circumference : 0;

  const addStroke = 'rgb(34 197 94)';
  const delStroke = 'rgb(239 68 68)';

  const commonCircle: any = {
    cx,
    cy,
    r,
    fill: 'none',
    strokeWidth,
    strokeLinecap: 'butt',
  };

  return (
    <span className="inline-flex shrink-0">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="img"
        aria-label={label}
        className="shrink-0 overflow-visible rounded-full ring-slate-400"
      >
        <g transform={`rotate(-90 ${cx} ${cy})`}>
          {total === 0 ? (
            <circle
              {...commonCircle}
              stroke="#9ca3af"
              strokeDasharray="none"
              pointerEvents="none"
            />
          ) : (
            <>
              <circle
                {...commonCircle}
                className="stroke-slate-400"
                strokeDasharray="none"
                pointerEvents="none"
              />
              {addLen > 0 && (
                <circle
                  {...commonCircle}
                  stroke={addStroke}
                  strokeDasharray={`${addLen} ${circumference}`}
                  strokeDashoffset={0}
                  pointerEvents="none"
                />
              )}
              {delLen > 0 && (
                <circle
                  {...commonCircle}
                  stroke={delStroke}
                  strokeDasharray={`${delLen} ${circumference}`}
                  strokeDashoffset={-addLen}
                  pointerEvents="none"
                />
              )}
            </>
          )}
        </g>
      </svg>
    </span>
  );
}
